<template>
  <!-- 清运点位 -->
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <!-- <el-form-item label="用户名">
          <el-input @keyup.enter.native="searchQuery" v-model="queryParam.name" placeholder="请输入"></el-input>
        </el-form-item>-->

        <el-form-item>
          <!-- <el-button type="primary" @click="searchQuery">查询</el-button> -->
          <!-- <el-button type="default" @click="searchReset">重置</el-button> -->
          <el-button size="mini" type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #sex="slotData">
        <p v-if="slotData.data.row.sex == 1">男</p>
        <p v-if="slotData.data.row.sex == 0">女</p>
        <p v-if="slotData.data.row.sex == 2">保密</p>
      </template>
      <!-- <template #handlerSlot="slotData">
        <el-button size="mini" @click="handleEdit(slotData.data.row)">修改</el-button>
        <el-button type="danger" size="mini" @click="handleDelete(slotData.data.row.id)">删除</el-button>
      </template> -->
    </e-table>
    <modal-form ref="modalForm" @ok="modalFormOk"></modal-form>
  </div>
</template>

<script>
import modalForm from './component/userModal'

import eTable from '@/components/table'
import { listMixin } from '@/mixins/listMixin'
export default {
  components: { eTable, modalForm },
  mixins: [listMixin],
  props: {},
  data () {
    return {
      deleteKey: 'userId',
      url: {
        list: '/wlCleanPointPosition/page',
        // delete: 'user/deleteUser',
      },

      //字段权限
      columns: [
        {
          field: 'wlCommunityName',
          label: '社区',
        },
        {
          field: 'pointPosition',
          label: '点位',
        },

        // {
        //   width: 260,
        //   label: '操作',
        //   slotName: 'handlerSlot',
        //   columnType: 'slot',
        // },
      ],
    }
  },
  watch: {},
  computed: {},
  methods: {
    fetchData () {
      console.log(this.ipagination.page)
    },
    add (val) {
      console.log(val)
    },
    edit (val) { },
    del (val) { },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
}
</style>
